module.exports = __webpack_public_path__ + "static/img/dsxt2.dc52ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/dsxt2.jpg
// module id = 310
// module chunks = 34